import { LitElement, html } from 'lit';
import { styles } from './css';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { classMap } from 'lit/directives/class-map.js';

export class Locations extends LitElement {
  static get styles() {
    return [styles];
  }

  constructor() {
    super();
  }

  render() {
    return html`
      <div class="page-wrapper">
        <div class="header">
          <h1>3form Locations</h1>
        </div>
        <div class="content-wrapper">
          ${this.pageData.map(
            location => html`
              <section class="location-wrapper">
                <h2>${location.name}</h2>
                ${location.description
                  ? html`
                      <p class="description">
                        ${unsafeHTML(location.description)}
                      </p>
                    `
                  : html``}
                ${location.contactInfo
                  ? html`
                      <div class="contact-info">
                        ${location.contactInfo.map(
                          contactPoint => html`
                            <div
                              class="${classMap({
                                row: true,
                                'added-padding': contactPoint[0] === 'Email',
                              })}"
                            >
                              <p class="descriptor">${contactPoint[0]}</p>
                              <p class="value">
                                ${unsafeHTML(this.valueHTML(contactPoint[1]))}
                              </p>
                            </div>
                          `
                        )}
                      </div>
                    `
                  : html``}
              </section>
            `
          )}
        </div>
      </div>
    `;
  }

  valueHTML(value) {
    if (typeof value === 'string') {
      return value;
    } else {
      console.log('value:', value);
      if (typeof value[0] === 'string') {
        return value.join('<br>');
      } else {
        let valueStr = '';
        value.forEach((section, index) => {
          section[0] = `<b>${section[0]}</b>`;
          valueStr = valueStr + section.join('<br>');
          if (index === 0) {
            valueStr = `${valueStr}<br><br>`;
          }
        });
        return valueStr;
      }
    }
  }

  get pageData() {
    return [
      {
        name: 'Corporate Headquarters',
        contactInfo: [
          ['Phone', '801-649-2500'],
          ['Toll-Free', '800-726-0126'],
          ['Fax', '801-649-2699'],
          ['Email', '<u>info@3-form.com</u>'],
          ['Location', ['2300 South 2300 West', 'Salt Lake City, UT 84119']],
        ],
      },
      {
        name: 'LightArt',
        contactInfo: [
          ['Phone', '206-524-2223'],
          ['Fax', '206-763-0588'],
          ['Email', '<u>info@lightart.com</u>'],
          [
            'Locations',
            [
              ['Seattle', '4770 Ohio Ave S, Suite B', 'Seattle, WA 98134'],
              [
                'Salt Lake City',
                '2300 South 2300 West',
                'Salt Lake City, UT 84119',
              ],
            ],
          ],
        ],
      },
      {
        name: 'Press',
        description: '3form, 3form Elements, LightArt',
        contactInfo: [
          ['Phone', '646-722-8146'],
          ['Email', '<u>3form@upspringpr.com</u>'],
        ],
      },
      {
        name: 'Outside North America',
        description:
          'We work with various distributors around the world. Contact us at <u>emea@3-form.com</u>, and we will route you to the appropriate point of contact.',
      },
    ];
  }
}

customElements.define('locations-block', Locations);
